import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MdDialogRef, MdDialog, MdDialogConfig, MdSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { NavigationService } from '@services/navigation-service';
import { DialogsService } from '@services/dialogs-service';
import { ProductoService } from '@services/producto-service';
import { PATH_PIZARRA } from '../../../navigation/navigation.module';
import { FormControl } from '@angular/forms';
import { PreciosService } from '@services/precios-service';
import * as moment from 'moment';
import {dateToUnixTime} from "@utils/DateHelper";
import { PricePipe } from '@utils/pipes';
import { PermisosService } from '@services/permisos-service';
import { MonedaService } from '@services/moneda-service';
import {NotificationSnackbarComponent} from '@common/snackbar/notification-snackbar/notification-snackbar.component';
import {PageHeaderComponent} from '@common/page-header';

@Component({
  selector: 'app-new-precio-pizarra',
  templateUrl: './new-precio-pizarra.component.html',
  styleUrls: ['./new-precio-pizarra.component.scss']
})
export class NewPrecioPizarraComponent implements OnInit {

  private productoOptions = [];
  private productoRows = [];
  private productosRows = [];
  private monedaOptions = [];
  private monedaRows = [];
  public priceStateControl = [];

  private maxDate = moment().toDate();
  private editFechaId = 0;

  public dummyDateContainer = null;

  @ViewChild('precioInput') priceInput: ElementRef;
  @ViewChild('datePicker') datePicker;
  @ViewChild(PageHeaderComponent) pageHeader: PageHeaderComponent;

  tipoMercadoOptions = [];
  tipoMercadoSelected = null;
  tipoMercadoSelectedName = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private productoService: ProductoService,
              private dialogsService: DialogsService,
              private navService: NavigationService,
              private snackBar: MdSnackBar,
              private preciosService: PreciosService,
              private pricePipe: PricePipe,
              private permisosService: PermisosService,
              private monedaService: MonedaService) {
    this.permisosService.verificarAccesoDeURL();
    productoService.Options.subscribe(newValue => {
      const date = this.getDefaultDate();
      this.productoOptions = newValue;
      this.productoRows = this.productoOptions.map(x => ({
        Id: x.ID,
        Producto: x.Producto,
        Precio: null,
        PrecioCargado: false,
        InputVisible: false,
        tmp: '',                  // guardamos la info del input sin procesar aqui
        error: false,             // verificamos si el input tiene error
        errorValue: '',           // guardamos el valor erroneo para no mantener el input activo
        fecha: date,
      }));
    });

    monedaService.Options.subscribe(newValue => {
      this.monedaOptions = newValue;
      this.monedaRows = this.monedaOptions.map(x => ({
        Id: x.ID,
        Moneda: x.Moneda,
        Simbolo: x.Simbolo
      }));
    });

    this.productoRows.forEach((p) => {
      this.monedaRows.forEach((m) => {
        const newRow = {
          Id: p.Id,
          Producto: p.Producto,
          Precio: null,
          PrecioCargado: false,
          InputVisible: false,
          tmp: '',                  // guardamos la info del input sin procesar aqui
          error: false,             // verificamos si el input tiene error
          errorValue: '',           // guardamos el valor erroneo para no mantener el input activo
          fecha: p.fecha,
          Mon_Id: m.Id,
          Moneda: m.Moneda,
          Simbolo: m.Simbolo
        };
        this.productosRows.push(newRow);
      });
    });

      this.productosRows.forEach((x, i) => {
        this.priceStateControl[i] = new FormControl();
      });

    this.preciosService.getMercadosPizarra().subscribe(res => {
      if (res) {
        this.tipoMercadoOptions = res.map(x => ({
          Nombre: x.Mercado,
          Id: x.Id
        }));
        this.tipoMercadoSelected = this.tipoMercadoOptions[0].Id;
        this.tipoMercadoSelectedName = ' - ' + this.tipoMercadoOptions[this.tipoMercadoOptions.findIndex(x => x.Id === this.tipoMercadoSelected)].Nombre;
      } else {
        this.snackBar.openFromComponent(NotificationSnackbarComponent, {
          duration: 2000,
          data: 'Ha ocurrido un error al obtener la lista de Mercados.',
          extraClasses: ['agd-warning-snackbar']
        });
      }
    });
  }

  ngOnInit() {
  }

  getDefaultDate() {
    // si nos encontramos en cualquiera de estos dias, obtendremos el valor de fecha del ultimo viernes
    const forbiddenDays = ['lunes', 'domingo', 'sábado'];
    if (forbiddenDays.indexOf(moment().format('dddd')) > -1) {
      let daysToSubtract = 1;
      while (moment().subtract(daysToSubtract, 'day').format('dddd') !== 'viernes') {
        daysToSubtract++;
      }
      return moment().subtract(daysToSubtract, 'day');
    } else {
      return moment().subtract(1, 'day');
    }
  }

  navigateBack() {
    let arePricesLoaded = false;
    this.productosRows.forEach(x => {
      if (x.Precio > 0) {
        arePricesLoaded = true;
      }
    });
    if (arePricesLoaded) {
      this.dialogsService.confirm(null,
        '¿Está seguro de salir sin cargar estos precios?',
        'SÍ, ACEPTAR',
        'NO, CANCELAR')
        .subscribe(res => {
          if (res) {
            this.pageHeader.catchEnded();
          }
        });
    } else {
      this.pageHeader.catchEnded();
    }
  }

  displayPriceInput(row) {
    row.InputVisible = true;
    row.tmp = row.Precio ? row.Precio.toString() : row.error ? row.errorValue : '';
    setTimeout(() => {
      this.priceInput.nativeElement.focus();
    }, 100);
  }

  savePriceInput(row) {
    if (!row.tmp.length) {
      row.Precio = null;
      row.error = false;
      row.errorValue = '';
    } else {
      const temp = row.tmp.replace(',', '.');
      if (Number.isNaN(Number(temp))) {
        row.error = true;
        row.Precio = null;
        row.errorValue = row.tmp;
      } else if (Number(temp) > 0 && Number(temp) < 1000000000) {
        row.Precio = Number(temp);
        row.error = false;
        row.errorValue = '';
      } else {
        row.error = true;
        row.Precio = null;
        row.errorValue = row.tmp;
      }
      this.dummyDateContainer = null;
    }
    row.InputVisible = false;
  }

  onSubmit() {
    // chequeamos si hay algun error
    if (this.productosRows.findIndex(v => v.error === true) >= 0) {
      this.snackBar.open('Uno o mas precios tiene errores', '', {
        duration: 2000,
      });
      return;
    }

    if (this.productosRows.findIndex(v => v.Precio !== null) < 0) {
      this.snackBar.open('Debe cargarse al menos un precio', '', {
        duration: 2000,
      });
      return;
    }

    if (!this.tipoMercadoOptions.length) {
      this.snackBar.open('No hay Mercados disponibles', '', {
        duration: 2000,
      });
      return;
    }

    // primero chequeamos que haya al menos un precio cargado
    let precios = this.productosRows.filter(x => x.Precio !== null);
    if (precios.length) {

      let string = '';

      precios.forEach(x => {
        string = string + ' ' + x.Producto + ': ' + this.pricePipe.transform(x.Precio, 'fill') + '<br>';
      });

      this.dialogsService.confirm(`¿Está seguro que desea cargar estos precios en Pizarra de ${this.tipoMercadoSelectedName}?`, string, 'ACEPTAR', 'CANCELAR')
        .subscribe(res => {
          if (res) {
            const mercado = this.tipoMercadoOptions[this.tipoMercadoOptions.findIndex(x => x.Id === this.tipoMercadoSelected)].Id;
            precios = precios.map(x => ({
              Precio: x.Precio,
              ProductoId: x.Id,
              MonedaId: x.Mon_Id,
              Fecha: dateToUnixTime(moment(x.fecha).toDate()),
              MercadoId: mercado
            }));
            this.preciosService.crearPreciosPizarra(precios)
              .subscribe(x => {
                if (x) {
                  this.snackBar.open('Se han enviado a validar los precios de Pizarra', '', {
                    duration: 2000,
                  });
                  this.router.navigateByUrl('/' + PATH_PIZARRA);
                }
              });
          }
        });
    }
  }

  showDatePicker(e) {
    // guardamos la posicion del picker seleccionado
    this.editFechaId = e;
    this.dummyDateContainer = null;
    this.datePicker.open();
  }

  onEditFecha(e) {
    // no se envia la row correcta al editar por lo que guardamos la posicion editada y la usamos como ID (this.editFechaId)
    // verificar que no se pase de HOY
    this.productosRows[this.editFechaId].fecha = moment(moment(e).format('YYYY-MM-DD'));
  }

  getFecha(row) {
    return moment(row.fecha).format('DD-MM-YYYY');
  }

  updateSelectedTipoMercadoName() {
    this.tipoMercadoSelectedName =  ' - ' + this.tipoMercadoOptions[this.tipoMercadoOptions.findIndex(x => x.Id === this.tipoMercadoSelected)].Nombre;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/new-precio-pizarra/new-precio-pizarra.component.ts